
























































































import { Component, Prop, Ref, Watch, Emit } from "vue-property-decorator";
import Vue from "vue";
import { getModule } from "vuex-module-decorators";
import Viewpoints from "@/store/modules/Viewpoints";
import Decisions from "@/store/modules/Decisions";
import Choices from "@/store/modules/Choices";
import { VIEWPOINT_API } from "@/api/ViewpointApi";
import { REQUIRED } from '@/rules';
import _ from "lodash";
import { FactorGroup, FactorResource } from '@/api/model/FactorResource';
import Modelling from '@/store/modules/Modelling';
import WorkspaceOptions from '@/store/modules/WorkspaceOptions';
import ExportRecursiveGroup from "@/views/FileExport/ExportRecursiveGroup.vue";
import { ChoiceInputFactorResource } from '@/types/ChoiceInputFactorResource';
import { API, Storage } from "aws-amplify";


const viewpointsModule = getModule(Viewpoints);
const choicesModule = getModule(Choices);
const decisionsModule = getModule(Decisions)
const modellingModule = getModule(Modelling);
const workspaceOptionsModule = getModule(WorkspaceOptions);

@Component({
    components: {
        ExportRecursiveGroup
    }

})

export default class ExportPreview extends Vue {

     @Prop()
    choiceForm!: any;

    styles!: any;

    private REQUIRED = REQUIRED
    private columnWidth: number = 200;

    private show = false;
    private selectionPath: string[] = [];
    
    private showLists = true;
    private generating = false;
    private name: string = this.selectedDecision ? this.selectedDecision.name : '';
    private loading = false;
    private alert = false;
    private alertText = "Create";
    private alertType = "success"
    private data = {}
    private columnWidthInternal = {};
    private modelFactorResources: { [id: string]: ChoiceInputFactorResource } | null = null
    private exportZeroWeights: boolean = false;

  uploadProgressPercent: number;
  
    mounted() {
        let myExport: HTMLElement = (document.getElementById("vp__export"))!;

    }
    
    get viewpointsList() {
        return _.sortBy((viewpointsModule.decisionViewpoints || []), 'name');
    }


    get selectedChoiceId() {
        return choicesModule.selectedChoiceId;
    }

    get choicesList() {
        return choicesModule.choicesList;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources
    }

    get selectedDecision() {
        return decisionsModule.selectedDecision
    }

    get choices() {
        return choicesModule.choices;
    }

    get choiceIds() {
        return this.choicesList.map((choice: any) => choice.id);
    }

    get displayChoiceIds() {
        return (this.choiceIds.filter((id: any) => id === this.selectedChoiceId))
    }

    get columnWidths() {
        for (let index in this.choiceIds) {
            let cId = this.choiceIds[index];
            Vue.set(this.columnWidthInternal, cId, this.columnWidth);
        }
        return this.columnWidthInternal;
    }

    @Watch("show")
    onShowChange() {
        this.name = "";
    }

    private cancel() {
        this.name = "";
        this.show = false;
        this.$emit('cancel');
    }

     private clear() {
        this.name = "";
    }

    @Emit('submit')
    private async submit() {
        console.log(document.getElementById("vp__export")?.innerHTML)
        let htmlData: string = document.getElementById("vp__export")?.innerHTML || '';
        let response = await this.uploadFile(htmlData);
        console.log(response)
        choicesModule.convertFile({data: process.env.VUE_APP_STORAGE_S3_BUCKET, fileName: 'public/' + response.key})
           .then(response => {
                var FileSaver = require('file-saver');
                FileSaver.saveAs(response);                    

                })
                .catch(err => {
                   console.log(err)
                })
    }

     private selectBreadcrumbItem(id: string) {
        workspaceOptionsModule.selectBreadcrumbItem(id);
    }

     private async uploadFile(data: string) {
        const key: string = `ingest/csv/${this.name}.html`;
        this.loading = true;
        let uploadResponse: any = await Storage.put(key, data, {
        progressCallback: (progress: any) => {
            this.uploadProgressPercent = progress.loaded / progress.total
        }
        })
        this.loading = false;
        this.loading = true;
        return uploadResponse;
  }

}
